<section class="pt-16 px-container">
    <app-breadcrumb-backoffice [items]="[{ label: 'Home', route: '/backoffice/home' }, { label: 'Configurazioni', route: '/backoffice/configurazioni/' }, { label: 'Modifica Configurazione', active: true }]"></app-breadcrumb-backoffice>
</section>

<section class="px-container pb-16">
    <form [formGroup]="formConfigurazione" class="accrediti-form flex flex-col gap-6" (ngSubmit)="onSubmit()">
        <div class="ac-section-head">
            <h2>Dati configurazione</h2>
            <span class="ac-meta">valore e descrizione opzionale</span>
        </div>

        <div class="fld">
            <label>* Valore</label>
            <input type="text" pInputText class="w-full" formControlName="value" name="value" id="value" required />
            <small class="text-red-600 block mt-2 font-medium" *ngIf="formConfigurazione.get('value')?.hasError('required') && (formConfigurazione.get('value')?.dirty || formConfigurazione.get('value')?.touched)">Il valore è obbligatorio.</small>
        </div>

        <div class="fld">
            <label>Descrizione <span class="ac-meta">(opzionale)</span></label>
            <input type="text" pInputText class="w-full" formControlName="descrizione" name="descrizione" id="descrizione" />
        </div>

        <div class="acc-actions">
            <p-confirmPopup #confirmDeletePopupRef>
                <ng-template pTemplate="headless" let-message>
                    <div class="border-round p-3">
                        <span class="text-base">{{ message.message }}</span>
                        <div class="flex align-items-center gap-2 mt-3">
                            <button type="button" class="acc-btn flex-1" (click)="onDelete()">Elimina</button>
                            <button type="button" class="acc-btn acc-btn-ghost flex-1" (click)="onAnnulla()">Annulla</button>
                        </div>
                    </div>
                </ng-template>
            </p-confirmPopup>
            <button class="acc-btn" type="button" (click)="onDeleteConfigurazionePopup($event)">Elimina configurazione</button>
            <a class="acc-btn acc-btn-ghost" routerLink="/backoffice/configurazioni">Annulla</a>
            <button class="acc-btn acc-btn-primary" type="submit" [disabled]="!formConfigurazione.valid">Salva modifiche</button>
        </div>
    </form>
</section>
